import MockAdapter from "axios-mock-adapter";
import moment from "moment";
import axios from 'axios';
import buildingData from './data/building.json';
import units from './data/units.json';
import sampleData from './data/sample.json';
import floorData from './data/locations_floor.json';
import results from './data/results.json';
import resultsCT from './data/resultsCT.json'
import speciesSample from './data/speciesSample.json'
import resultsSpecies from './data/resultsSpecies.json'
import speciesResult from './data/speciesResults.json'
import  speciesBuliding from './data/speciesBuilding.json'
import speciesFloorData from './data/speciesLocation_floor.json';
import speciesUnits from './data/speciesUnits.json'
import snp from './data/snp.json'
import snpLocations from './data/snpLocations.json'

var id  = 20001
const sample = {
  "id": null,
  "sample_id": null,
  "organism": null,
  "date_time": null,
  "comments": null,
  "type_of_samples":  null,
  "type_of_analysis": null,
  "reference_genome": null,
  "picture": null,
  "batch_no": null,
  "type_of_testing": null,
  "barcode": null,
  "count": 0,
  "classical_sample_id": null,
  "is_ngs_sample_created": false,
  "is_result_generated": false,
  "location": null,
  "unit": null,
  "parent": null
}

var date = new Date();
date.setDate(date.getDate() - 1);
var sampleID = parseInt(date.toISOString().split('T')[0].split('-').join("")+ ("0000" + 1).slice(-4))

let samplesData = localStorage.getItem('species')?speciesSample:sampleData
samplesData.forEach(data =>{
  data.sample_id = sampleID
  data.date_time = date
  if(results.length>=sampleID%10000){
    results[sampleID%10000 - 1].sample.sample_id = sampleID
  }
  sampleID  += 1
})


samplesData.sort((a, b) => (a.date_time < b.date_time) ? 1 : -1)

const mock = new MockAdapter(axios);

if(!localStorage.getItem("guest")){
    mock.restore();
}
else
{
  mock.onGet("/filters/").reply(()=>{
    let filters = {
      "organismList": ["Bacteria", "Salmonella"],
      "typeOfSamplesList": ["Water", "Food"],
      "typeOfAnalysisList": ["cgMLST", "Other", "SNP"],
      "batchNoList": ["Batch 01", "Batch 02"],
      "referenceGenomeList": [],
      "speciesFindingList": [],
      "sequenceTypeList": [],
      "complexTypeList": [],
      "novelTypeList": [],
      "snpDistanceList": []
    }
    return [200, filters]
  });

  mock.onGet("/complextype/").reply((config)=>{
    var CT = {}
    var resultData = JSON.parse(JSON.stringify(localStorage.getItem('species')?resultsSpecies:resultsCT))
    let from = new Date(config.params.from_date)
    let to = new Date(config.params.to_date)
    
      resultData.forEach( result => {
        let dateTime = new Date(result.sample.date_time)
        let batchNo = config.params.batch_no === result.sample.batch_no || !config.params.batch_no
        let typeofsample = config.params.type_of_sample === result.sample.type_of_samples || !config.params.type_of_sample
        if(result.sample.organism===config.params.organism && from.getTime()<=dateTime.getTime() && 
        to.getTime()>=dateTime.getTime() && typeofsample && batchNo){
            if(CT[result.complex_type])
              CT[result.complex_type] += 1
            else
              CT[result.complex_type] = 1
       }
      })
    let complexList = Object.keys(CT).map((key) => [key, CT[key]])
    complexList.sort((a, b) => (a[1] > b[1]) ? 1 : -1)
    return [200, {"complexList": complexList}]
  });

  mock.onGet("/samplecount/").reply((config)=>{
    let samples_period = config.params.ct_period;
    let filter = config.params.filter_type
    let resultsData 
    if (filter === 'complex_type') {
      resultsData = [
        { "complex_type": "7297", "Count": "10" },
        { "complex_type": "9826", "Count": "8" },
        { "complex_type": "124", "Count": "5" },
        { "complex_type": "1487", "Count": "4" },
        { "complex_type": "7365", "Count": "5" },
        { "complex_type": "111", "Count": "8" },
        { "complex_type": "321", "Count": "5" },
        { "complex_type": "233", "Count": "4" },
        { "complex_type": "3873", "Count": "3" },
        { "complex_type": "3874", "Count": "5" },
        { "complex_type": "other", "Count": "18" },
      ]
    }
    else {
      resultsData = [
        { "sequence_type": "5656", "Count": "9" },
        { "sequence_type": "1845", "Count": "20" },
        { "sequence_type": "2020", "Count": "5" },
        { "sequence_type": "7672", "Count": "4" },
        { "sequence_type": "4524", "Count": "5" },
        { "sequence_type": "673", "Count": "8" },
        { "sequence_type": "4203", "Count": "5" },
        { "sequence_type": "4532", "Count": "4" },
        { "sequence_type": "156", "Count": "3" },
        { "sequence_type": "8794", "Count": "5" },
        { "sequence_type": "other", "Count": "8" },
      ]
    }
    if (samples_period === "Yearly" && filter === 'complex_type') {
      resultsData = [
        { "complex_type": "7297", "Count": "9" },
        { "complex_type": "9826", "Count": "8" },
        { "complex_type": "998", "Count": "5" },
        { "complex_type": "1487", "Count": "4" },
        { "complex_type": "7365", "Count": "5" },
        { "complex_type": "111", "Count": "4" },
        { "complex_type": "321", "Count": "5" },
        { "complex_type": "233", "Count": "4" },
        { "complex_type": "2345", "Count": "3" },
        { "complex_type": "3874", "Count": "5" },
        { "complex_type": "other", "Count": "20" },
      ]

    }
    else if (samples_period === "Monthly" && filter === 'complex_type') {
      resultsData = [
        { "complex_type": "455", "Count": "6" },
        { "complex_type": "9826", "Count": "8" },
        { "complex_type": "998", "Count": "5" },
        { "complex_type": "1487", "Count": "2" },
        { "complex_type": "7365", "Count": "5" },
        { "complex_type": "111", "Count": "2" },
        { "complex_type": "321", "Count": "5" },
        { "complex_type": "233", "Count": "4" },
        { "complex_type": "2345", "Count": "3" },
        { "complex_type": "3874", "Count": "5" },
        { "complex_type": "other", "Count": "16" },
      ]
    }
    else if (samples_period === "Weekly" && filter === 'complex_type') {
      resultsData = [
        { "complex_type": "455", "Count": "6" },
        { "complex_type": "9826", "Count": "8" },
        { "complex_type": "998", "Count": "5" },
        { "complex_type": "100", "Count": "2" },
        { "complex_type": "7365", "Count": "5" },
        { "complex_type": "111", "Count": "2" },
        { "complex_type": "321", "Count": "5" },
      ]
    }
    if (samples_period === "Yearly" && filter === 'sequence_type') {
      resultsData = [
        { "sequence_type": "5656", "Count": "4" },
        { "sequence_type": "1845", "Count": "18" },
        { "sequence_type": "2020", "Count": "5" },
        { "sequence_type": "7672", "Count": "4" },
        { "sequence_type": "4524", "Count": "2" },
        { "sequence_type": "673", "Count": "8" },
        { "sequence_type": "4203", "Count": "2" },
        { "sequence_type": "4532", "Count": "1" },
        { "sequence_type": "156", "Count": "3" },
        { "sequence_type": "8794", "Count": "5" },
        { "sequence_type": "other", "Count": "6" },
      ]
    }
    if (samples_period === "Monthly" && filter === 'sequence_type') {
      resultsData = [
        { "sequence_type": "8787", "Count": "1" },
        { "sequence_type": "1845", "Count": "18" },
        { "sequence_type": "2020", "Count": "5" },
        { "sequence_type": "7672", "Count": "4" },
        { "sequence_type": "4524", "Count": "2" },
        { "sequence_type": "673", "Count": "8" },
        { "sequence_type": "4203", "Count": "2" },
        { "sequence_type": "4532", "Count": "1" },
        { "sequence_type": "156", "Count": "3" },
        { "sequence_type": "8794", "Count": "5" },
        { "sequence_type": "other", "Count": "4" },
      ]
    }
    if (samples_period === "Weekly" && filter === 'sequence_type') {
      resultsData = [
        { "sequence_type": "8787", "Count": "1" },
        { "sequence_type": "1845", "Count": "18" },
        { "sequence_type": "2020", "Count": "5" },
        { "sequence_type": "7672", "Count": "4" },
        { "sequence_type": "4524", "Count": "2" },
        { "sequence_type": "8123", "Count": "8" },
        { "sequence_type": "100", "Count": "2" },
        { "sequence_type": "4532", "Count": "1" },
      ]
    }

    let locations_count =  localStorage.getItem('species')? [
      {
        "location__description": "Region A, Map A, Zone 9",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 9",
        "unit": null,
        "Samples": 14,
        "Results": 6
      },
      {
        "location__description": "Region A, Map A, Zone 1",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 1",
        "unit": null,
        "Samples": 8,
        "Results": 3
      },
      {
        "location__description": "Region A, Map A, Zone 6",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 6",
        "unit": null,
        "Samples": 5,
        "Results": 2
      },
      {
        "location__description": "Region A, Map A, Zone 1, Door Handle",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 1",
        "unit": "Door Handle",
        "Samples": 5,
        "Results": 4
      },
      {
        "location__description": "Region A, Map A, Zone 2",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 2",
        "unit": null,
        "Samples": 4,
        "Results": 2
      },
      {
        "location__description": "Region A, Map A, Zone 5",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 5",
        "unit": null,
        "Samples": 4,
        "Results": 2
      },
      {
        "location__description": "Region A, Map A, Zone 3",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 3",
        "unit": null,
        "Samples": 4,
        "Results": 3
      },
      {
        "location__description": "Region A, Map A, Zone 7",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 7",
        "unit": null,
        "Samples": 3,
        "Results": 1
      },
      {
        "location__description": "Region A, Map A, Zone 8",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 8",
        "unit": null,
        "Samples": 2,
        "Results": 1
      },
      {
        "location__description": "Region A, Map A, Zone 4",
        "building": "Region A",
        "floor": "Map A",
        "room": "Zone 4",
        "unit": null,
        "Samples": 2,
        "Results": 2
      },
      {
        "location__description": "other",
        "building": null,
        "floor": null,
        "room": null,
        "unit": null,
        "Samples": 24,
        "Results": 12
      }
    ]:[
      {
        "location__description": "Building A, Floor A, Packaging Room",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Packaging Room",
        "unit": null,
        "Samples": 14,
        "Results": 6
      },
      {
        "location__description": "Building A, Floor A, Incoming Goods Room",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Incoming Goods Room",
        "unit": null,
        "Samples": 8,
        "Results": 3
      },
      {
        "location__description": "Building A, Floor A, Cold Room 1",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Cold Room 1",
        "unit": null,
        "Samples": 5,
        "Results": 2
      },
      {
        "location__description": "Building A, Floor A, Incoming Goods Room, Door Handle",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Incoming Goods Room",
        "unit": "Door Handle",
        "Samples": 5,
        "Results": 4
      },
      {
        "location__description": "Building A, Floor A, Hygiene Room",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Hygiene Room",
        "unit": null,
        "Samples": 4,
        "Results": 2
      },
      {
        "location__description": "Building A, Floor A, Tools Room",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Tools Room",
        "unit": null,
        "Samples": 4,
        "Results": 2
      },
      {
        "location__description": "Building A, Floor A, Assembly Room 1",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Assembly Room 1",
        "unit": null,
        "Samples": 4,
        "Results": 3
      },
      {
        "location__description": "Building A, Floor A, Cold Room 2",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Cold Room 2",
        "unit": null,
        "Samples": 3,
        "Results": 1
      },
      {
        "location__description": "Building A, Floor A, Machinery Room",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Machinery Room",
        "unit": null,
        "Samples": 2,
        "Results": 1
      },
      {
        "location__description": "Building A, Floor A, Assembly Room 2",
        "building": "Building A",
        "floor": "Floor A",
        "room": "Assembly Room 2",
        "unit": null,
        "Samples": 2,
        "Results": 2
      },
      {
        "location__description": "other",
        "building": null,
        "floor": null,
        "room": null,
        "unit": null,
        "Samples": 24,
        "Results": 12
      }
    ]

    let samplesFilter = config.params.samples_period
    let complexPeriod = config.params.complex_period
    let seqPeriod = config.params.seq_period
    let dashData = {
      "totalSamples": samplesData.length,
      "total_waiting_samples": [...samplesData.filter((sample) => !(sample.is_result_generated))].length,
      "total_SNP_samples": [...samplesData.filter((sample) => sample.type_of_analysis==="SNP")].length,
      "total_cgMLST_samples": [...samplesData.filter((sample) => sample.type_of_analysis==="cgMLST")].length,
      "total_Other_samples": 12, //[...samplesData.filter((sample) => sample.type_of_analysis==="Other")].length,
      "waiting_SNP_samples": [...samplesData.filter((sample) => !(sample.is_result_generated) && sample.type_of_analysis==="SNP")].length,
      "waiting_cgMLST_samples": [...samplesData.filter((sample) => !(sample.is_result_generated) && sample.type_of_analysis==="cgMLST")].length,
      "waiting_Other_samples": [...samplesData.filter((sample) => !(sample.is_result_generated) && sample.type_of_analysis==="Other")].length,
      "positive_result": [...results.filter(result => result.other_analysis === "Positive")].length,
      "negative_result": [...results.filter(result => result.other_analysis === "Negative")].length,
      "total_microbiome_samples": 42,
      "waiting_microbiome_samples": 14,
      "recent_activity": [
        {
          "user": "Admin",
          "last_action_time": "2021-09-21T13:08:08.363864Z",
          "object": "Result",
          "count": "1",
          "added_values": localStorage.getItem('species')?"Microbiome":"cgMLST"
        },
        {
          "user": "Guest",
          "last_action_time": samplesData[0].date_time,
          "object": "Sample",
          "count": "1",
          "added_values": "MF7988"
        },
        {
          "user": "Admin",
          "last_action_time": new Date(),
          "object": "Floor",
          "count": "1",
          "added_values": "Floor A"
        },
        {
          "user": "Guest",
          "last_action_time": new Date(),
          "object": "Unit",
          "count": "1",
          "added_values": "Chair"
        },  
        {
          "user": "Admin",
          "last_action_time": new Date(),
          "object": "Building",
          "count": "1",
          "added_values": "Building A"
        },
      ],
      "listeria_CT": complexPeriod==="Monthly"?"3568":complexPeriod==="Weekly"?"998":"4296",
      "listeria_ST": seqPeriod==="Monthly"?"19":seqPeriod==="Weekly"?"403":"121",
      "salmonella_CT": complexPeriod==="Monthly"?"8096":complexPeriod==="Weekly"?"7126":"111",
      "salmonella_ST": seqPeriod==="Monthly"?"3063":seqPeriod==="Weekly"?"3":"732",
      "locations_data": resultsData,
      "locations_count": samplesFilter === "Yearly"?locations_count.slice(0,locations_count.length-1):samplesFilter === "Monthly"?locations_count.slice(0,locations_count.length-4):samplesFilter === "Weekly"?locations_count.slice(0,locations_count.length-7):locations_count
    }
    return [200, dashData]
  });
  
  mock.onGet("/buildings/").reply(200, localStorage.getItem('species')?speciesBuliding:buildingData);

  mock.onGet("/locations/units/").reply(200, localStorage.getItem('species')?speciesUnits:units);

  mock.onGet("/samples/").reply((config) =>{
    let locationId = config.params.location_id
    let isResultGenerated= config.params.is_result_generated
    let data = JSON.parse(JSON.stringify(samplesData))
    if(locationId)
      data = [...data.filter((item) => item.location.location_id===locationId)]
    if(isResultGenerated===false || isResultGenerated===true)
      data = [...data.filter((item) => isResultGenerated===item.is_result_generated)]
    return [200, data]
  });

  mock.onPost("/samples/").reply(function (config) {
    let building = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesBuliding:buildingData))
    let returnArray = Object.fromEntries(config.data)
    returnArray.id = id
    const date = new Date()
    returnArray.sample_id = date.toISOString().split('T')[0].split('-').join("")+ ("0000" + id%20000).slice(-4)
    returnArray.location = {
        location_id: returnArray.location,
        units: [],
        floor: building[0]["floors"][0]
    }
    returnArray.location.floor.building = {
        "id": 20000,
        "building_id": "BldgA",
        "building_name": "Building A",
    }
    if(returnArray.unit)
        returnArray.unit = null
    
    returnArray = {...Object.assign(sample, returnArray)};
    samplesData.splice(0, 0, returnArray)
    id += 1
    return [201, returnArray];
  });

  mock.onDelete("/samples/delete/").reply((config) =>{
    config.params.ids.split(',').forEach(data => {
      let index = samplesData.findIndex((element) => parseInt(element.id)===parseInt(data))
      samplesData.splice(index, 1)
    });
    return [204, {}];
  });

  mock.onPut(/\/samples\/\d+/).reply(function (config) {
    var returnArray = Object.fromEntries(config.data)
    let building = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesBuliding:buildingData))
    let index = samplesData.findIndex((element) => { 
        if(element.id === parseInt(returnArray.id))
            return true
        return false
     })
     returnArray.location = {
        location_id: returnArray.location,
        units: [],
        floor: building[0]["floors"][0]
    }
    returnArray.location.floor.building = {
        "id": 20000,
        "building_id": "BldgA",
        "building_name": "Building A",
    }
    if(returnArray.unit)
        returnArray.unit = null
    if(returnArray.is_result_generated==="false")
      returnArray.is_result_generated=false
    else if (returnArray.is_result_generated==="true")
      returnArray.is_result_generated=true
    
    Object.assign(samplesData[index], returnArray);
    return [200, returnArray];
  });

  mock.onDelete(/\/samples\/\d+/).reply((config) =>{
    let index = samplesData.findIndex((element) => { 
        if(element.id === config.url.split('/').slice(-2, -1))
        return true
        return false
     })
     samplesData.splice(index, 1)
    return [204, {}];
  });

  mock.onGet("/locations/").reply((config)=>{    
    var resultArray = []
    var data = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesFloorData:floorData))
    var count = 0
    data["locations_data"]["data"].forEach( data =>{
      samplesData.forEach( sample => {
        if(data.location_id === sample.location.location_id && sample.is_result_generated===false){
          let today
          if(config.params.date_time !== ""){
            today = moment(new Date(sample.date_time)).isSame(new Date(config.params.date_time), 'day')
            if(today){
              data["samples"].push(sample)
              count += 1
            }
            return;
          }
          else{
            data["samples"].push(sample)
            count += 1
          }
        }
      })
      resultArray.push(data);
    })

    data["locations_data"]["data"] = resultArray
    data["stats"]["total_samples"] = count
    return [200, data]
  });

  mock.onGet("locations/results/").reply((config)=>{
    var resultArray = []
    var data = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesFloorData:floorData))
    var resultData = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesResult:results))
    var samples = JSON.parse(JSON.stringify(samplesData))
    var count = 0
    var locations = data["locations_data"]["data"].map( data => data.location_id)
    var date = new Date(config.params.date_time);
    var sampleID = parseInt(date.toISOString().split('T')[0].split('-').join("")+ ("0000" + 1).slice(-4))

    samples.forEach(sample =>{
      if(Math.floor(Math.random() *3)){
      sample.sample_id = sampleID
      sample.date_time = date
      if(resultData.length>=sampleID%10000){
        resultData[sampleID%10000 - 1].sample.sample_id = sampleID
      }
      sample.location.location_id = locations[Math.floor(Math.random() * locations.length)]
      sampleID  += 1
    }
    })

    data["locations_data"]["data"].forEach( data =>{
      samples.forEach( sample => {
        let today = moment(new Date(sample.date_time)).isSame(new Date(config.params.date_time), 'day')
        let analysis = (sample.type_of_analysis === config.params.analysis) || (sample.type_of_analysis !=="Other" && config.params.analysis!=="Other")
        let organism = config.params.organism === sample.organism || !config.params.organism
        let typeofsample = config.params.type_of_samples === sample.type_of_samples || !config.params.type_of_samples
        if(data.location_id === sample.location.location_id && sample.is_result_generated===true && today && analysis && organism && typeofsample){
          resultData.every((result) =>{
              if(result.sample.id===sample.id){
                result.sample = sample.id
                sample.result = result
                sample.location = sample.location.location_id
                data["samples"].push(sample)
                count += 1
                return false
              }
              return true
            })
        }
      })
      resultArray.push(data);
    })

    let len =   [...samplesData.filter((sample) =>{
      let today = moment(new Date(sample.date_time)).isSame(new Date(config.params.date_time), 'day')
      let analysis = (sample.type_of_analysis === config.params.analysis) || (sample.type_of_analysis !=="Other" && config.params.analysis!=="Other")
      let organism = config.params.organism === sample.organism || !config.params.organism
      let typeofsample = config.params.type_of_samples === sample.type_of_samples || !config.params.type_of_samples
      if(sample.is_result_generated === false && today && analysis && organism && typeofsample)
        return true
      return false
    })].length
    data["locations_data"]["data"] = resultArray
    data["stats"]["total_samples"] = count + len
    data["stats"]["results"] = count
    return [200, data]
  });

  mock.onGet("locations/ctresults/").reply((config)=>{
    var resultArray = []
    var ctParams = config.params.complex_type.split(',')
    var CT = ctParams.reduce((acc, curr)=> {
        acc[curr]=0 
        return acc
      }, {});
    var data = JSON.parse(JSON.stringify(localStorage.getItem('species')?speciesFloorData:floorData))
    var resultData = JSON.parse(JSON.stringify(localStorage.getItem('species')?resultsSpecies:resultsCT))
    let from = new Date(config.params.date_time_after)
    let to = new Date(config.params.date_time_before)
    data["locations_data"]["data"].forEach( data =>{
      data.complex_type = []
      resultData.forEach( result => {
        let dateTime = new Date(result.sample.date_time)
        let batchNo = config.params.batch_no === result.sample.batch_no || !config.params.batch_no
        let typeofsample = config.params.type_of_samples === result.sample.type_of_samples || !config.params.type_of_samples
        if(data.location_id === result.sample.location.location_id && ctParams.includes(result.complex_type) && typeofsample && batchNo &&
          result.sample.organism===config.params.organism && from.getTime()<=dateTime.getTime() && to.getTime()>=dateTime.getTime()){
              let index = data.complex_type.findIndex(type => type.complex_type === result.complex_type);
              if(index === -1){
                let samplesData = []
                samplesData.push({
                  "complex_type": result.complex_type,
                  "novel_type": result.novel_type,
                  "sample__barcode": result.sample.barcode,
                  "sample__date_time": result.sample.date_time,
                  "sample__location": data.location_id,
                  "sample__type_of_analysis": result.sample.type_of_analysis,
                  "sample__type_of_samples": result.sample.type_of_samples,
                  "sequence_type": result.sequence_type
                })
                data.complex_type.push({
                  "complex_type": result.complex_type,
                  "sample__location": data.location_id,
                  "complex_type__count": 1,
                  "sample__location_id__count": 1,
                    "samples": samplesData,
                })
              }
              else{
                
                let samplesData = {
                  "complex_type": result.complex_type,
                  "novel_type": result.novel_type,
                  "sample__barcode": result.sample.barcode,
                  "sample__date_time": result.sample.date_time,
                  "sample__location": data.location_id,
                  "sample__type_of_analysis": result.sample.type_of_analysis,
                  "sample__type_of_samples": result.sample.type_of_samples,
                  "sequence_type": result.sequence_type
                }
                let sampleIndex = data.complex_type[index].complex_type__count
                data.complex_type[index].complex_type__count += 1
                data.complex_type[index].sample__location_id__count += 1
                data.complex_type[index].samples[sampleIndex] = samplesData
              }
              CT[result.complex_type] += 1
       }
      })
      resultArray.push(data);
    })
    data["locations_data"]["data"] = resultArray
    data["stats"]["CT"] = [Object.keys(CT).map((key) => {return {"complex_type": key, "complex_count": CT[key]}})]
    return [200, data]
  });
  
  mock.onGet("locations/track_snp_distance/").reply((config)=>{
    let snpLocationsData = JSON.parse(JSON.stringify(snpLocations))
    let barcodes = config.params.barcode.split(',')
    snpLocationsData[config.params.organism].locations_data.data.forEach( data => {
      if(data.barcode.length>0)
        data.barcode =  [...data.barcode.filter(sample => barcodes.includes(sample.sample__barcode))]
    })
    return [200, snpLocationsData[config.params.organism]?snpLocationsData[config.params.organism]:{}]
  });

  mock.onGet("/batchno/").reply((config)=>{
    return [200, config.params.organism==="Salmonella"?{batchNoList: [["Batch 01"]]}:{batchNoList: [["Batch 02"]]}]
  })

  mock.onGet(/\/groups\/\w+/).reply((config)=>{
    let organism = config.url.split('/').slice(1, 2)
    return [200, organism==="Salmonella"?{organism: "Salmonella", groups: "10,25"}:{organism: "Liseria", groups: "3,30"}]
  })

  mock.onGet("locations/snp_results/").reply((config)=>{
    return [200, snp[config.params.organism]?snp[config.params.organism]:{}]
  });

  mock.onGet(/\/locations\/\w+/).reply((config) =>{
    let buildingsData = localStorage.getItem('species')?speciesBuliding:buildingData
    let index = buildingsData[0]["floors"][0]["locations"].findIndex((element) => {
        if(element.location_id === config.url.split('/').slice(-2, -1)[0])
        return true
        return false
     })
    return [200, index!==-1?buildingsData[0]["floors"][0]["locations"][index]:{}];
  });
  
  mock.onGet("/results/").reply((config)=>{
    let from = new Date(config.params.date_time_after)
    let to = new Date(config.params.date_time_before)
    let results = localStorage.getItem('species')?resultsSpecies:resultsCT
    if(!config.params.organism) 
     return [200, results];
    else
     return [200,[...results.filter(data => {
      let dateTime = new Date(data.sample.date_time)
      let batchNo = config.params.batch_no === data.sample.batch_no || !config.params.batch_no
      let typeofsample = config.params.type_of_samples === data.sample.type_of_samples || !config.params.type_of_samples
       if(config.params.complex_type.split(',').includes(data.complex_type) && batchNo && typeofsample &&
       data.sample.organism===config.params.organism && from.getTime()<=dateTime.getTime() && to.getTime()>=dateTime.getTime())
        return true
      return false
      })]]
  });

  mock.onDelete("/results/delete/").reply((config) =>{
    config.params.ids.split(',').forEach(data => {
      let index = resultsCT.findIndex((element) => element.id===parseInt(data))
      resultsCT.splice(index, 1)
    });
    return [204, {}];
  });

}